import React, { useState, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import {
  getTicketActionModal,
  postPostponeTicket,
} from '../../../../../actions/index';
import {
  generateTicketPostponeEndpoint,
  TICKET_POSTPONE_MODAL_ENDPOINT,
} from '../../../../../config/endpoints';
import withEndpointAuthorization from '../../../authorization/withEndPointAuthorization';
import { POST } from '../../../../../config/permissions';
import { MODAL_ACTION_CONFIRM_MESSAGE } from '../../../../../config/messages';
import Modal from '../../../../common/modal/Modal';
import TicketPostponeForm from '../TicketPostponeForm';

const PostponeTicketButton = ({
  dispatchPostPostponeTicket,
  ticketId,
  forThirdParty,
  dispatchGetTicketActionModal,
  ticket,
  disabled
}) => {
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(MODAL_ACTION_CONFIRM_MESSAGE);
  const [url, setUrl] = useState(null);

  const handleShowModal = async () => {
    setLoading(true);

    const response = await dispatchGetTicketActionModal({
      ticketId,
      url: TICKET_POSTPONE_MODAL_ENDPOINT,
    });

    if (response && response.message && response.url) {
      setMessage(response.message);
      setUrl(response.url);
      setShowConfirmationModal(true);
    }

    setLoading(false);
  };

  const handleCloseModal = () => setShowConfirmationModal(false);

  const handlePostponeTicket = (formValues) => {
    const newFormValues = {
      ...formValues,
      ticketId,
      creditNoteMotive: formValues.creditNoteMotive
        ? formValues.creditNoteMotive.value
        : null,
      creditNoteMotiveDescription: formValues.creditNoteMotiveDescription
        ? formValues.creditNoteMotiveDescription
        : null,
    };

    dispatchPostPostponeTicket(url, ticketId, newFormValues, forThirdParty);
  };

  const body = (
    <TicketPostponeForm
      message={message}
      onSubmit={handlePostponeTicket}
      onCancel={handleCloseModal}
      ticket={ticket}
    />
  );

  return (
    <>
      <Button
        color="light"
        className="border"
        onClick={handleShowModal}
        disabled={loading || disabled}
      >
        <i className={`fa fa-${loading ? 'spinner fa-spin' : 'calendar'}`} />{' '}
        Postergar
      </Button>
      <Modal
        show={showConfirmationModal}
        title="Confirmación de Postergación"
        body={body}
        cancelButtonColor="primary"
      />
    </>
  );
};

PostponeTicketButton.propTypes = {
  dispatchPostPostponeTicket: PropTypes.func.isRequired,
  ticketId: PropTypes.number.isRequired,
  forThirdParty: PropTypes.bool,
  dispatchGetTicketActionModal: PropTypes.func.isRequired,
  ticket: PropTypes.shape({
    id: PropTypes.number.isRequired,
    transactions: PropTypes.arrayOf(
      PropTypes.shape({
        paymentMethod: PropTypes.shape({
          id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
        }).isRequired,
        creditNoteId: PropTypes.number,
        business: PropTypes.shape({
          id: PropTypes.number,
          name: PropTypes.string,
          businessTaxId: PropTypes.string,
        }),
      }),
    ).isRequired,
    manualPaymentMethod: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      transactionCode: PropTypes.string,
    }),
    manualVoucherCode: PropTypes.string,
    customer: PropTypes.shape({
      idDocumentNumber: PropTypes.string,
    }),
    creditNoteTotalAmount: PropTypes.number,
    salePrice: PropTypes.number,
  }).isRequired,
  disabled: PropTypes.bool
};

PostponeTicketButton.defaultProps = {
  forThirdParty: false,
  disabled: false,
};

const mapDispatchToProps = {
  dispatchPostPostponeTicket: postPostponeTicket,
  dispatchGetTicketActionModal: getTicketActionModal,
};

const connectedComponent = connect(
  null,
  mapDispatchToProps,
)(PostponeTicketButton);

export default withEndpointAuthorization({
  url: generateTicketPostponeEndpoint(0),
  permissionType: POST,
})(connectedComponent);
